// @flow
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import {
    FormattedMessage, injectIntl, IntlShape,
} from 'react-intl';
import { withConfirmation } from 'speed-js-react';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import MainActions from 'esm-web-pro/components/layout/sidePanel/MainActions';
import type { Match, RouterHistory } from 'react-router-dom';
import dataPortMessage from 'esm-web-pro/messages/dataPortMessages';
import DataPortEditor from 'esm-web-pro/containers/pages/network/objects/dataport/DataPortEditor';
import { bindActionCreators } from 'redux';
import * as sidePanelActions from 'esm-web-pro/redux/side-panel/actions';
import { connect } from 'react-redux';
import TimelineIcon from 'esm-web-pro/components/layout/sidePanel/icons/TimelineIcon';


type SidePanelActionProps = {
    openPanel: (key: string, url: ?string, skipSensitivity?: boolean) => { key: string, url: string },
    closePanel: (key: string, skipSensitivity: boolean) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    dataPort: Object,
    onEdit: Function,
    intl: IntlShape,
    history: RouterHistory,
    match: Match,
    map: Object,
    resource: Object,
    // eslint-disable-next-line react/no-unused-prop-types
    updateObject: Function,
    editor: Object,
}

const DATA_PORT_EDIT_KEY = 'DATA_PORT_EDIT';

class DataPortActions extends React.Component <Props> {
    handleClose = (skipSensitivity = false) => {
        const { closePanel } = this.props;
        closePanel(DATA_PORT_EDIT_KEY, skipSensitivity);
    };

    handleSave = (newValues) => {
        const { onEdit } = this.props;
        onEdit(newValues);
        this.handleClose(true);
    };

    getActions = () => {
        const {
            intl: { formatMessage }, dataPort, match, history,
        } = this.props;

        const actions = [];
        const regex = /^(.+?)(\/+)$/gm;

        actions.push({
            key: 'splice-timeline',
            icon: <TimelineIcon />,
            tooltip: formatMessage(actionMessages.timeline),
            callback: () => history.push(`${match.url.replace(regex, '$1')}/timeline/dataport/${dataPort.identity}`),
            marginVertical: '15px',
            radius: '0%',
            color: 'transparent',
        });

        return actions;
    };

    render() {
        const {
            dataPort, resource, history, match, updateObject, intl: { formatMessage }, map: { uuid: mapUuid }, editor,
        } = this.props;

        return (
            <>
                <SidePane
                    id={DATA_PORT_EDIT_KEY}
                    key={dataPort.uuid}
                    title={(
                        <FormattedMessage
                            id="dataport-editor-title"
                            defaultMessage="Edit {type}"
                            values={{ type: formatMessage(dataPortMessage.dataport).toLowerCase() }}
                        />
                    )}
                >
                    <DataPortEditor
                        id={DATA_PORT_EDIT_KEY}
                        point={{ ...dataPort, infrastructure_provider: dataPort.container.infrastructure_provider }}
                        // objectLayer={objectLayer}
                        onClose={this.handleClose}
                        onSave={this.handleSave}
                        mapUuid={mapUuid}
                        resource={resource}
                        match={match}
                        history={history}
                        updateObject={updateObject}
                        editor={editor}
                    />
                </SidePane>
                <MainActions main actions={this.getActions()} />
            </>
        );
    }
}


const mapDispatchToProps = (dispatch) => (
    bindActionCreators(sidePanelActions, dispatch)
);

export default
withRouter(
    withConfirmation(
        injectIntl(
            connect(null, mapDispatchToProps)(DataPortActions),
        ),
    ),
);
